// extracted by mini-css-extract-plugin
export default {"container":"loading-overlay_container__MD6QZ","spinner":"loading-overlay_spinner__VywJa","spin":"loading-overlay_spin__gCmOI"};